import Dkbr from './Dikobraz'

import Demo from '@@/demo/vue/Demo'
import Dt from '@dt/Deeptensor'

export default [
    {
        //name: 'dkbr',
        path: '',
        component: Dkbr,
        children: [
            {
                name: 'demo',
                path: 'demo',
                component: Demo,
                children: [],
            },
            {
                //name: 'dt',
                path: '',
                component: Dt,
                children: Dt.routes || [],
            },
        ],
    },
]



// WEBPACK FOOTER //
// ./main/routes.js